import { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { useNavigate } from "react-router-dom";
// import MSSQL from "../../images/MSSQL.png";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import MySQL from "../../images/MySQL.png";
// import PostgreSQL from "../../images/PostgreSQL.jpeg";

function MySqlKbDetails() {
  const productID = sessionStorage.getItem("productid");
  const [kbVersions, setKbVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [data, setData] = useState({
    productVersionIDs: [],
    productVersionNames: [],
  });
  const navigate = useNavigate();

  async function fetchProductVersions() {
    const response = await fetch(`/allVersionsByID/${productID}`);
    const result = await response.json();
    setData(result);
  }
  async function fetchKbVersions() {
    const response = await fetch(
      `/knowledgeBasesByVersionID/${selectedVersion}`);

    const result = await response.json();
    if (Array.isArray(result) && result.length > 0) {
      setKbVersions(result);
    } else {
      setKbVersions([]);
    }
  }
  useEffect(() => {
    fetchProductVersions();
  }, [productID]);
  useEffect(() => {
    fetchKbVersions();
  }, [selectedVersion]);

  return (
    <section className="p-4">
      <div className="grid align-items-center">
        <div className="col-12 md:col-6">
          <h1 className="fs-h1">MYSQL Database</h1>
          <p className="fs-p mt-2">
            MySQL is an open-source RDBMS that is widely used in web development
            because of its ease of use and performance. It is known for its
            high-performance and low-cost. It's a popular choice for small- to
            medium-sized projects and web applications, and is also used in many
            popular content management systems (CMS) such as WordPress and
            Joomla. It also offers support for various programming languages
            such as C, C++, Java, Perl, PHP, Python, and Ruby.MainProduct==
            {productID}, MainProduct==
            {selectedVersion},
          </p>
          <hr className="my-2" />
          <h3>Choose Your Database Version</h3>

          <Dropdown
            value={selectedVersion}
            onChange={(e) => {
              setSelectedVersion(e.value);
              fetchKbVersions();
            }}
            options={
              data && data.productVersionNames
                ? data.productVersionNames.map((selectIdTwo, index) => ({
                    label: selectIdTwo,
                    value: data.productVersionIDs[index],
                  }))
                : []
            }
            optionLabel="label"
            placeholder="Select MySQL Version"
            className="w-full md:w-20rem my-2"
            scrollHeight="100px"
            virtualScrollerOptions={{ itemSize: 40 }}
            filter
            checkmark={true}
            highlightOnSelect={true}
          />
          <div className="flex gap-2 mt-2">
            <Button
              label="Back"
              icon="pi pi-arrow-left"
              className="p-button-outlined"
              onClick={() => navigate("/")}
            />
          </div>
        </div>
        <div className="col-12 md:col-6 text-center">
          <img
            src={MySQL}
            alt="MySQL"
            className="w-full "
            style={{ borderRadius: "12px" }}
          />
        </div>
      </div>
      <Divider />
      <Card className="shadow-5 m-3">
        <h2 className="text-center">Kb Vesrion Details</h2>
        <div className="flex justify-content-between">
          <Button
            label="Back"
            icon="pi pi-arrow-left"
            size="small"
            rounded
            className="p-info"
            onClick={() => navigate("/")}
          />
          <Dropdown
            value={selectedVersion}
            onChange={(e) => {
              setSelectedVersion(e.value);
              fetchKbVersions();
            }}
            options={
              data && data.productVersionNames
                ? data.productVersionNames.map((selectIdTwo, index) => ({
                    label: selectIdTwo,
                    value: data.productVersionIDs[index],
                  }))
                : []
            }
            optionLabel="label"
            placeholder="Select MySQL Version"
            className="w-full md:w-20rem my-2"
            scrollHeight="100px"
            virtualScrollerOptions={{ itemSize: 40 }}
            filter
            checkmark={true}
            highlightOnSelect={true}
          />
        </div>
        <DataTable
          value={kbVersions}
          tableStyle={{ minWidth: "50rem" }}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 30, 500]}
          removableSort
          scrollable
          scrollHeight="500px"
          size="small">
          <Column field="kbdetail" header="KB Detail"></Column>
          <Column field="kburl" header="URL"></Column>
          <Column field="releasedate" header="Release Date"></Column>
          <Column field="buildnumber" header="Build No"></Column>
          <Column field="fileversion" header="File Version"></Column>
        </DataTable>
      </Card>
    </section>
  );
}

export default MySqlKbDetails;
